import { type JSX } from 'react'
import { Icon as IconLibary } from '../icon-library'

const catergoryIcon: Record<string, { name: any; class: string }> = {
  2037749: { name: 'laptop', class: 'laptop' },
  2037751: { name: 'computer', class: 'computer' },
  2029798: { name: 'server', class: 'server' },
  2029786: { name: 'network-wifi-2', class: 'network-wifi-2' },
  2029772: { name: 'services', class: 'services' },
  2029808: { name: 'storage', class: 'storage' },
  2037759: { name: 'printer', class: 'printer' },
  2029810: { name: 'phone', class: 'phone' },
  2037866: { name: 'headphones', class: 'headphones' },
  2029978: { name: 'label', class: 'label' },
  2029788: { name: 'office-4', class: 'office' },
  2037737: { name: 'code', class: 'code' },
  2029898: { name: 'bargain', class: 'bargain' },
  1591819568073007: { name: 'label', class: 'label' },
  1591819568099575: { name: 'label', class: 'label' },
  1591819567974019: { name: 'gaming', class: 'gaming' },
  1591819568061558: { name: 'gaming', class: 'gaming' },
  idea: { name: 'idea', class: 'idea' },
  bargain: { name: 'bargain', class: 'bargain' },
  folder: { name: 'folder', class: 'folder' },
  label: { name: 'label', class: 'label' },
  solutions: { name: 'document-license', class: 'document-license' },
} as const

export const getMainCategoryIcon = (id: string, className: string): JSX.Element | null => {
  if (!id) return null
  const iconId = id.startsWith('StructureGroup') ? id.split('_')[1] || 'folder' : id
  const icon = catergoryIcon[iconId]

  if (!icon) return null

  return <IconLibary name={icon.name} className={`${className || ''}`} />
}
